var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.showNewLetterFields || _vm.viewMode
        ? _c(
            "ValidationObserver",
            { ref: "generateLetterForm" },
            [
              _c("add", {
                attrs: {
                  "alert-missing-document": _vm.alertMissingDocument,
                  "is-readonly": _vm.isReadonly || _vm.viewMode
                },
                model: {
                  value: _vm.model,
                  callback: function($$v) {
                    _vm.model = $$v
                  },
                  expression: "model"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "row" }, [
        _vm.areSignersTypeMissing
          ? _c("span", {
              staticClass: "col-12 error-message",
              domProps: { innerHTML: _vm._s(_vm.missingSignersType) }
            })
          : _vm._e()
      ]),
      !_vm.viewMode
        ? [
            _c("custom-separator", {
              staticClass: "pt-3 my-4",
              attrs: { text: "Lista de Cartas" }
            }),
            !_vm.pagination?.data
              ? _c("custom-result-not-found", {
                  attrs: { text: "No hay información disponible." }
                })
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                _vm._l(_vm.pagination?.data, function(item, index) {
                  return _c("letter-row", {
                    key: index,
                    staticClass: "mb-3",
                    attrs: { item: item },
                    on: {
                      delete: function($event) {
                        return _vm.removeSignature(index)
                      },
                      refresh: function($event) {
                        return _vm.fetchLetters({ page: 1 })
                      },
                      view: function($event) {
                        return _vm.viewSignature(item)
                      }
                    }
                  })
                }),
                1
              )
            ]),
            _vm.showPagination
              ? _c("pagination", {
                  attrs: { data: _vm.pagination, "show-text": true },
                  on: { "pagination-go-page": _vm.goToPage }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }